import React from "react";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { createRoot } from 'react-dom/client';
import { SoftUIControllerProvider } from "context";
import { GoogleOAuthProvider } from "@react-oauth/google";
import './App.css';
import RoutesProvider from "context/RoutesContext";
import { QueryParamsProvider } from "context/QueryParamsContext";
import { DateFormatProvider } from "context/DateFormatContext";
import { UserProvider } from "context/UserContext";
import { DomainProvider } from "context/DomainContext";
import { SitesProvider } from "context/SitesContext";
import { AuthProvider } from 'context/AuthContext';
import { SettingsProvider } from "context/SettingsContext";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "msalConfig";
import { PublicClientApplication } from "@azure/msal-browser";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const msalInstance = new PublicClientApplication(msalConfig);

function renderApp() {
  const container = document.getElementById("root");
  const root = createRoot(container);

  root.render(
    <BrowserRouter>
      <SoftUIControllerProvider>
        <MsalProvider instance={msalInstance}>
          <GoogleOAuthProvider clientId={CLIENT_ID}>
            <AuthProvider>
              <SettingsProvider>
                <DomainProvider>
                  <UserProvider>
                    <SitesProvider>
                      <RoutesProvider>
                        <QueryParamsProvider>
                          <DateFormatProvider>
                            <App />
                          </DateFormatProvider>
                        </QueryParamsProvider>
                      </RoutesProvider>
                    </SitesProvider>
                  </UserProvider>
                </DomainProvider>
              </SettingsProvider>
            </AuthProvider>
          </GoogleOAuthProvider>
        </MsalProvider>
      </SoftUIControllerProvider>
    </BrowserRouter>
  );
}

msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise()
    .then((response) => {
      if (response) {
        msalInstance.setActiveAccount(response.account);
        window.__msalRedirectResponse = response;
      }
    })
    .catch((error) => {
      console.error("MSAL redirect error:", error);
    })
    .finally(() => {
      renderApp();
    });
}).catch((error) => {
  console.error("MSAL initialization failed:", error);
  renderApp();
});